<template>
  <custom-callout
    class-main="rounded"
    :has-toggle="false"
    :border-color="data.status.color"
  >
    <div class="row py-2 mr-md-0 align-items-center pr-5">
      <div class="row col-12">
        <div
          class="
              col-12 col-md-2
              px-0
              pt-3
              border-right border-right--variant
              d-flex
              justify-content-center
            "
        >
          <div class="col-12 row d-flex font-weight-bold font-17 px-0">
            <div class="font-weight-normal color-gray font-14">
              <i
                class="fas fa-circle mr-2 font-12"
                :style="`color: ${data.status.color}`"
              />
              <span class="font-16 font-weight-bold">
                {{ data.status.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9 row mx-0">
          <div class="col-12 col-lg-3 col-md-6 mt-3 mt-md-0 pl-4">
            <span class="data-title d-block">Período de Reembolso:</span>
            <div v-if="data.periods.length > 0">
              <div class="px-2">
                <span
                  v-for="(period, idx) in data.periods"
                  :key="idx"
                  class="px-0"
                >
                  {{ period.periodName }}

                  <span
                    v-if="idx != Object.keys(data.periods).length - 1"
                    class="spam-separator"
                  >
                    ,
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3 col-md-6 mt-3 mt-md-0 pl-4">
            <span class="data-title d-block">Número de Consulta:</span>
            {{ data.businessId }}
          </div>
          <div class="col-12 col-lg-3 col-md-6 mt-3 mt-md-0 pl-4">
            <span class="data-title d-block">Número de Reembolso:</span>
            {{ data.requestNumber }}
          </div>
          <div class="col-12 col-lg-3 col-md-6 mt-3 mt-md-0 pl-4">
            <span class="data-title d-block">Vigencia:</span>
            {{ data.assignmentDateToShow }}
          </div>
        </div>
        <div class="col-12 col-md-1 mt-3 mt-md-0 pt-2">
          <drop-down :items="actionItems" />
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';

export default {
  name: 'ResultRow',
  components: { CustomCallout, DropDown },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    actionItems() {
      return [
        {
          label: 'Ver Detalle',
          icon: 'fas fa-file-search color-green',
          visible: true,
          click: () => this.goToDetail(),
        },
      ];
    },
  },
  methods: {
    goToDetail() {
      this.$router.push({
        name: 'student-reinbursement',
        params: {
          tapRequestId: this.data.tapRequestId,
          requestId: this.data.requestId,
          fromRefundHistory: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
span[class^='badge-status-'] {
  padding: 0.5rem 0;
  min-width: 90%;
}
</style>
